module.exports = __webpack_public_path__ + "static/demoscreen2test-09429ee85802a9e025f565aa8a3e8d22.png";